var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 14,
    height: 14,
    rx: 2.5,
    stroke: "#E8E13F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28 10.045C9.28 9.66 9.28 9.51 9.47 9.195C9.635 8.925 9.93 8.725 10.245 8.385C10.7 7.905 11.03 7.345 11.03 6.66C11.03 6.2 10.865 5.73 10.57 5.39C10.14 4.87 9.455 4.66 8.72 4.66C8.24 4.66 7.745 4.805 7.36 5.08C6.87 5.42 6.565 6.025 6.5 6.69H7.77C7.76 6.415 7.855 6.17 8.055 6.01C8.225 5.86 8.49 5.795 8.765 5.795C9.095 5.795 9.41 5.89 9.595 6.135C9.715 6.28 9.755 6.475 9.755 6.695C9.755 7.04 9.685 7.32 9.42 7.62C8.915 8.155 8.56 8.255 8.295 8.78C8.085 9.15 8.005 9.585 8.005 10.045H9.28ZM8.645 12.095C9.065 12.095 9.37 11.78 9.37 11.375C9.37 10.97 9.065 10.655 8.645 10.655C8.235 10.655 7.925 10.97 7.925 11.375C7.925 11.78 8.235 12.095 8.645 12.095Z",
    fill: "#E8E13F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.93b6013c.svg";
export { ForwardRef as ReactComponent };